import { createAsyncThunk, createReducer, createAction } from '@reduxjs/toolkit';
import { API, SCOPE_CRM_DASHBOARD } from '../../constants';
import { application } from '../../services/application';

export const INITIAL_STATE = {
  weekStart: null,
  weekEnd: null,
  contactsAdded: 0,
  organizationsAdded: 0,
  contactsTouched: 0,
  notesThisWeek: 0,
  byStage: [],
  byOrigin: [],
  byType: [],
  lastTouch: {
    items: [],
    count: 0,
    order: ['lastContacted', 'asc'],
    pagination: { page: 1, perPage: 10 },
    pending: false,
    loaded: false,
  },
  pending: false,
  loaded: false,
  breakdownsLoaded: false,
};

export const fetchWeeklyKpis = createAsyncThunk(`${SCOPE_CRM_DASHBOARD}/fetchWeeklyKpis`, (params) => {
  return application.call(API.CRM_DASHBOARD.GET_WEEKLY_KPIS, params);
});

export const fetchContactBreakdowns = createAsyncThunk(`${SCOPE_CRM_DASHBOARD}/fetchContactBreakdowns`, () => {
  return application.call(API.CRM_DASHBOARD.GET_CONTACT_BREAKDOWNS);
});

export const fetchContactsByLastTouch = createAsyncThunk(
  `${SCOPE_CRM_DASHBOARD}/fetchContactsByLastTouch`,
  (params = {}, { getState }) => {
    const { lastTouch } = getState().crmDashboard;

    return application.call(API.CRM_DASHBOARD.GET_CONTACTS_BY_LAST_TOUCH, {
      page: params.page ?? lastTouch.pagination.page,
      perPage: params.perPage ?? lastTouch.pagination.perPage,
      orderBy: params.orderBy ?? lastTouch.order[0],
      orderDir: params.orderDir ?? lastTouch.order[1],
    });
  }
);

export const setLastTouchOrder = createAction(`${SCOPE_CRM_DASHBOARD}/setLastTouchOrder`);
export const setLastTouchPage = createAction(`${SCOPE_CRM_DASHBOARD}/setLastTouchPage`);
export const setLastTouchPerPage = createAction(`${SCOPE_CRM_DASHBOARD}/setLastTouchPerPage`);

export const actions = {
  fetchWeeklyKpis,
  fetchContactBreakdowns,
  fetchContactsByLastTouch,
  setLastTouchOrder,
  setLastTouchPage,
  setLastTouchPerPage,
};

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(fetchWeeklyKpis.pending, (state) => {
      state.pending = true;
    })
    .addCase(fetchWeeklyKpis.fulfilled, (state, action) => {
      state.pending = false;
      state.loaded = true;
      state.weekStart = action.payload?.weekStart || null;
      state.weekEnd = action.payload?.weekEnd || null;
      state.contactsAdded = action.payload?.contactsAdded || 0;
      state.organizationsAdded = action.payload?.organizationsAdded || 0;
      state.contactsTouched = action.payload?.contactsTouched || 0;
      state.notesThisWeek = action.payload?.notesThisWeek || 0;
    })
    .addCase(fetchWeeklyKpis.rejected, (state) => {
      state.pending = false;
    })
    .addCase(fetchContactBreakdowns.pending, (state) => {
      state.pending = true;
    })
    .addCase(fetchContactBreakdowns.fulfilled, (state, action) => {
      state.pending = false;
      state.breakdownsLoaded = true;
      state.byStage = action.payload?.byStage || [];
      state.byOrigin = action.payload?.byOrigin || [];
      state.byType = action.payload?.byType || [];
    })
    .addCase(fetchContactBreakdowns.rejected, (state) => {
      state.pending = false;
    })
    .addCase(fetchContactsByLastTouch.pending, (state) => {
      state.lastTouch.pending = true;
    })
    .addCase(fetchContactsByLastTouch.fulfilled, (state, action) => {
      state.lastTouch.pending = false;
      state.lastTouch.loaded = true;
      state.lastTouch.items = action.payload?.items || [];
      state.lastTouch.count = action.payload?.count || 0;
      state.lastTouch.order = [action.payload?.orderBy || 'lastContacted', action.payload?.orderDir || 'asc'];
      state.lastTouch.pagination = {
        page: action.payload?.page || 1,
        perPage: action.payload?.perPage || 10,
      };
    })
    .addCase(fetchContactsByLastTouch.rejected, (state) => {
      state.lastTouch.pending = false;
    })
    .addCase(setLastTouchOrder, (state, action) => {
      const [orderBy, orderDir] = action.payload || [];
      state.lastTouch.order = [orderBy, orderDir];
      state.lastTouch.pagination.page = 1;
    })
    .addCase(setLastTouchPage, (state, action) => {
      state.lastTouch.pagination.page = action.payload;
    })
    .addCase(setLastTouchPerPage, (state, action) => {
      state.lastTouch.pagination.perPage = action.payload;
      state.lastTouch.pagination.page = 1;
    });
});
